import type { OutboxEntry } from '../types/outbox-entry';
import type { RecordView } from '../types/record-view';
import type { StoredRecord } from '../types/stored-record';
import { mergePatch } from './merge-patch';

function createdView(entry: OutboxEntry, actor: string): RecordView {
  return {
    id: entry.record_id,
    collection: entry.collection,
    data: mergePatch({}, entry.patch),
    rev: 0,
    created_at: entry.client_ts,
    created_by: actor,
    updated_at: entry.client_ts,
    updated_by: actor,
    deleted_at: null,
    pending: true,
  };
}

/** Apply pending mutations (oldest first) to the server's state of one record. */
export function applyOutbox(
  base: StoredRecord | undefined,
  entries: readonly OutboxEntry[],
  actor = '',
): RecordView | undefined {
  let view: RecordView | undefined = base ? { ...base, pending: false } : undefined;
  for (const entry of entries) {
    const at = entry.client_ts;
    if (entry.kind === 'upsert') {
      if (view?.deleted_at) continue; // the server will refuse it (sync.record_deleted)
      view = view
        ? {
            ...view,
            data: mergePatch(view.data, entry.patch),
            updated_at: at,
            updated_by: actor,
            pending: true,
          }
        : createdView(entry, actor);
    } else if (view) {
      const deleted_at = entry.kind === 'delete' ? (view.deleted_at ?? at) : null;
      view = { ...view, deleted_at, updated_at: at, updated_by: actor, pending: true };
    }
  }
  return view;
}
